import React from "react";
import { graphql } from "gatsby";
import { Process as ProcessComponent } from "@zempler/theme/src/components/process/Process";
import { NestedComponentRenderer } from "../../NestedComponentRenderer";

export const Process = ({ data, ...rest }) => {
  const items = data?.items?.map((item) => {
    const nestedComponents = item?.components.map((item) => {
      const { component } = item;

      return {
        ...component,
        areas: undefined,
      };
    });

    return {
      ...item,
      components: <NestedComponentRenderer components={nestedComponents} />,
    };
  });

  return <ProcessComponent items={items} {...rest} />;
};

export const ProcessQuery = graphql`
  fragment Process on UMBRACO_ProcessComponentType {
    items {
      backgroundColor
      components {
        component {
          ...AccordionComponents
        }
      }
    }
  }
`;
